export const get_currency_conversion = `query get_currency_conversion($id: String!){
    get_currency_conversion(id: $id){
        transaction_code
        status
        account
        from_currency{
            currency
            name
            decimal
        }
        to_currency{
            currency
            name
            decimal
        }
        from_amount
        to_amount
        exchange_rate
        order_date
        fulfillment_date
    }
}`;
